import { useGomakeTheme } from "@/hooks/use-gomake-thme";

export const ProductsSettingsIcon = () => {
    const { primaryColor } = useGomakeTheme();
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="vuesax/linear/main-component">
            <g id="main-component">
                <path id="Vector" d="M17.4582 12.125L12.1331 17.45C10.9665 18.6167 9.04982 18.6167 7.87482 17.45L2.5498 12.125C1.38314 10.9583 1.38314 9.04168 2.5498 7.86668L7.87482 2.54167C9.04148 1.37501 10.9581 1.37501 12.1331 2.54167L17.4582 7.86668C18.6248 9.04168 18.6248 10.9583 17.4582 12.125Z" stroke={primaryColor(500)} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Vector_2" d="M5.20801 5.20833L14.7913 14.7917" stroke={primaryColor(500)} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Vector_3" d="M14.7913 5.20833L5.20801 14.7917" stroke={primaryColor(500)} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
        </g>
    </svg>

}